import ApiRequest from "../index"

const deliveryPolicy = {
  get: async data => ApiRequest.get(`/v2/lojinha/complements/delivery`),
  put: async data => ApiRequest.put(`/v2/lojinha/complements/delivery`, { ...data })
}

export default deliveryPolicy
